import React from 'react';
import { TICK_PADDING } from '../../compute/labels/constants';
import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';
import { createSafeStylesAccessor } from '../../helpers/cssHelpers';
import { useChartScales } from '../ChartScales';
import Label from './Label';
import AxisTitle from './AxisTitle';

function Axes({ width, height, data, chartType }) {
  const { get } = useReportConfiguration();
  const { margins, labels } = useChartScales();

  const safeStyles = createSafeStylesAccessor(get() || {});

  const chartWidth = width - margins.left - margins.right;
  const chartHeight = height - margins.top - margins.bottom;

  const horizontalSlant = get(['horizontalAxis', 'labelSlant']) || 0;
  const verticalSlant = get(['verticalAxis', 'labelSlant']) || 0;

  const horizontalTitle = get(['horizontalAxis', 'title']);
  const verticalTitle = get(['verticalAxis', 'title']);

  const horizontalAxisEnabled =
    chartType !== 'PieChart' && get(['horizontalAxis', 'enabled']);
  const verticalAxisEnabled =
    chartType !== 'PieChart' && get(['verticalAxis', 'enabled']);

  const horizontalLabelFormat = safeStyles.getHorizontalAxisLabelFormat();
  const verticalLabelFormat = safeStyles.getVerticalAxisLabelFormat();

  return (
    <>
      {horizontalAxisEnabled && (
        <div
          style={{
            position: 'absolute',
            top: margins.top + chartHeight,
            left: margins.left,
            width: chartWidth,
            height: margins.bottom,
          }}
        >
          {labels.x.map(label => (
            <Label
              key={label.formattedValue}
              value={label.formattedValue}
              coords={{ left: label.position, top: TICK_PADDING }}
              size={label.width}
              axis='x'
              slant={horizontalSlant}
              style={horizontalLabelFormat}
            />
          ))}

          {horizontalTitle && (
            <AxisTitle orientation='horizontal' width={chartWidth}>
              {horizontalTitle}
            </AxisTitle>
          )}
        </div>
      )}

      {verticalAxisEnabled && (
        <div
          style={{
            position: 'absolute',
            top: margins.top,
            left: 0,
            width: margins.left,
            height: chartHeight,
          }}
        >
          {labels.y.map(label => (
            <Label
              key={label.formattedValue}
              value={label.formattedValue}
              coords={{ top: label.position, right: TICK_PADDING }}
              size={label.width}
              axis='y'
              slant={90 - verticalSlant}
              style={verticalLabelFormat}
            />
          ))}

          {verticalTitle && (
            <AxisTitle orientation='vertical' width={chartHeight}>
              {verticalTitle}
            </AxisTitle>
          )}
        </div>
      )}
    </>
  );
}

export default Axes;
